export enum OrderByEnum {
  ASC = "ASC",
  DESC = "DESC",
}

export type OrderBy<T> = {
  [key in keyof T]?: OrderByEnum;
};
